import { gql, useSubscription } from '@apollo/client';
import { useContext, useEffect } from 'react';
import { CompanyContext } from '../../context/CompanyContext';
import React from 'react';
import { forNotification } from '../Common/forNotification';
import { ContainerFragment } from '../../graphql/container.graphql';
import { Container } from '../../types/container';
import { useAppDispatch } from '../../ui/pages/store';
import { containerSlice } from '../../providers/ContainerProvider';

const containerSubscription = gql`
  subscription containerNotification($companyId: String!) {
    containerNotification(companyId: $companyId) {
      companyId
      entities {
        ...Container
      }
      topic
      date
    }
  }
  ${ContainerFragment.container}
`;

export class ContainerNotificationResponse extends forNotification<Container>('containerNotification') {}

export default function ContainerNotification({}) {
  const { currentCompany } = useContext(CompanyContext);
  const dispatch = useAppDispatch();

  if (!currentCompany) return null;

  const { data: containerNotifaction } = useSubscription<ContainerNotificationResponse>(containerSubscription, {
    variables: { companyId: currentCompany.id },
  });

  const handleContainerNotification = (notification?: ContainerNotificationResponse) => {
    if (!notification?.containerNotification) return;
    const containerNotification = notification.containerNotification;

    switch (containerNotification.topic) {
      case 'CREATE':
      case 'UPDATE':
        dispatch(containerSlice.actions.add(containerNotification.entities));
        break;
      case 'DELETE':
        dispatch(containerSlice.actions.delete(containerNotification.entities));
        break;
    }
  };

  useEffect(() => {
    handleContainerNotification(containerNotifaction);
  }, [containerNotifaction]);

  return <></>;
}
